import React from 'react';

import LinkItem from '../LinkItem';

import useStyles from './LinkGroup.styles';

export type LinkGroupProps = {
  links: LinkType[];
};

const LinkGroup = ({ links }: LinkGroupProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div> </div>
      {links.map((link, i) => (
        <LinkItem key={`link_${i}`} link={link} />
      ))}
    </div>
  );
};

export default LinkGroup;
